export const CATALOGUE_HOME_ROUTE: string = "/catalogue";
export const INDUCTION_HOME_ROUTE: string = "/induction";
export { LEARNING_PATHS_HOME_ROUTE } from "@core/consts/learning-paths-routes.constants";
